// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body[data-v-7bcdaa5b]{padding:16px 8px!important}.guestbox[data-v-7bcdaa5b]{margin:0 auto;line-height:46px;text-align:left;font-size:16px;color:#676767}.gb-td[data-v-7bcdaa5b]{padding:8px 7px}.age[data-v-7bcdaa5b]{font-size:11px}.btn[data-v-7bcdaa5b]{width:48px;height:48px;line-height:1;border-radius:50%;font-size:30px;padding:4px}", ""]);
// Exports
module.exports = exports;
